import { EDITAR_BREADCRUMB } from "./types";

export const editarBreadcrumb = ( rutas ) => dispatch => {
    dispatch({
        type: EDITAR_BREADCRUMB,
        payload: rutas
    });
}